module.exports = __webpack_public_path__ + "img/upload1.8a6d037a.png";